module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XUYcoY/tc-custom/9781497613362.jpg?1720280500095",
      "alt": "This image is the cover for the book Paradox Alley, Skyway"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Paradox Alley, Skyway\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The conclusion to the classic Skyway series by the award-winning author of "), _c('i', [_vm._v("Castle Perilous")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" Jake McGraw, independent space trucker, has been shanghaied. He and his crew, fresh off their adventures in "), _c('i', [_vm._v("Starrigger")]), _vm._v(" and "), _c('i', [_vm._v("Red Limit Freeway")]), _vm._v(", are plucked off the Skyway by a creature of unknown power. Now on an alien planet where most of the rules of the regular universe do not seem to apply, Jake confronts the builders of the Skyway once and for all. Will he and his crew make it out alive?"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John DeChancie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John DeChancie is a popular author of numerous science fiction and fantasy novels, including the hugely entertaining Castle series and the Starrigger trilogy. He grew up near Pittsburgh, Pennsylvania, and now lives in Los Angeles, California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0